import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_SERVICE_CONTROL_REQUEST_STATUS_LIST,
    CLEAR_SERVICE_CONTROL_REQUEST_STATUS_LIST_ERROR,
    LOAD_SERVICE_CONTROL_REQUEST_STATUS_LIST_REQUEST,
    LOAD_SERVICE_CONTROL_REQUEST_STATUS_LIST_SUCCESS,
    LOAD_SERVICE_CONTROL_REQUEST_STATUS_LIST_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_SERVICE_CONTROL_REQUEST_STATUS_LIST,
    CLEAR_ERROR: CLEAR_SERVICE_CONTROL_REQUEST_STATUS_LIST_ERROR,
    LOAD_REQUEST: LOAD_SERVICE_CONTROL_REQUEST_STATUS_LIST_REQUEST,
    LOAD_SUCCESS: LOAD_SERVICE_CONTROL_REQUEST_STATUS_LIST_SUCCESS,
    LOAD_FAILURE: LOAD_SERVICE_CONTROL_REQUEST_STATUS_LIST_FAILURE
}